import { useEffect, useRef, useState } from "react";
import { KAKAO_JS_KEY_FALLBACK, loadKakaoSdk } from "@/lib/kakao";

interface MiniMapProps {
  lat: number;
  lon: number;
  name: string;
  className?: string;
}

// 회원 상세용 카카오맵 미니맵 (마커 1개)
export default function MiniMap({ lat, lon, name, className = "" }: MiniMapProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    const container = containerRef.current;
    if (!container || !Number.isFinite(lat) || !Number.isFinite(lon)) {
      setError("좌표 정보가 없습니다.");
      return () => {
        active = false;
      };
    }

    loadKakaoSdk(KAKAO_JS_KEY_FALLBACK)
      .then((kakao) => {
        if (!active || !containerRef.current) return;
        const center = new kakao.maps.LatLng(lat, lon);
        const map = new kakao.maps.Map(containerRef.current, {
          center,
          level: 4,
        });
        const marker = new kakao.maps.Marker({ position: center, map });
        const overlay = new kakao.maps.CustomOverlay({
          position: center,
          yAnchor: 2.4,
          content: `<div style="padding:4px 8px;border-radius:6px;background:#ffffff;font-size:12px;font-weight:600;color:#1f2937;box-shadow:0 1px 4px rgba(0,0,0,.2);white-space:nowrap;">${name}</div>`,
        });
        overlay.setMap(map);
        return () => {
          marker.setMap(null);
        };
      })
      .catch(() => {
        if (active) setError("지도를 불러오지 못했습니다.");
      });

    return () => {
      active = false;
    };
  }, [lat, lon, name]);

  if (error) {
    return (
      <div
        className={`flex items-center justify-center rounded-xl border border-background-200 bg-background-100 text-sm text-foreground-400 ${className}`}
      >
        {error}
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      className={`overflow-hidden rounded-xl border border-background-200 bg-background-100 ${className}`}
      role="img"
      aria-label={`${name} 위치 지도`}
    ></div>
  );
}